module.exports = __webpack_public_path__ + "img/cupids_singing.4372a7ba.jpg";